<div class="flex flex-col gap-3">
    <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" placeholder="Buscar por nome ou CPF (mín. 2 caracteres)..." [(ngModel)]="termoBusca" (ngModelChange)="onTermoChange($event)" class="w-full" />
    </p-iconfield>

    @if (carregando()) {
        <div class="flex justify-center py-4">
            <i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i>
        </div>
    }

    @if (!carregando() && buscaRealizada()) {
        <p-table [value]="resultados()" styleClass="p-datatable-sm" [rowHover]="true" stripedRows [scrollable]="true" scrollHeight="280px">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 40px"></th>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>UF</th>
                    <th class="text-center" style="width: 90px">Ação</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <app-pessoa-avatar [foto]="item.avatar" [iniciais]="iniciais(item.nome)" [nome]="item.nome" tamanho="md" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, item.nome)" />
                    </td>
                    <td>
                        <div class="flex flex-col gap-0.5">
                            <span class="font-medium text-sm">{{ item.nome }}</span>
                            @if (item.email) {
                                <span class="text-xs text-muted-color">{{ item.email }}</span>
                            }
                        </div>
                    </td>
                    <td class="font-mono text-sm">{{ item.cpf || '—' }}</td>
                    <td class="text-sm">{{ item.uf }}</td>
                    <td class="text-center">
                        <p-button label="Selecionar" size="small" (onClick)="selecionar(item)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="text-center text-muted-color py-4">Nenhum resultado para "{{ termoBusca }}".</td>
                </tr>
            </ng-template>
        </p-table>
    }
</div>

<app-pessoa-foto-dialog [(foto)]="fotoAmpliada" [nome]="nomeFotoAmpliada()" />
